const BRAND = "My Private Chemist";

export function stripHtml(text) {
  if (!text || typeof text !== "string") return "";
  return text
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&#?\w+;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function formatPageTitle(name, brand = BRAND) {
  if (!name) return brand;
  const brandPipe = new RegExp(`\\s*\\|\\s*${brand.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}.*$`, "i");
  const leadingBrand = new RegExp(`^${brand.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*\\|\\s*`, "i");
  const pageName = String(name).replace(brandPipe, "").replace(leadingBrand, "").trim();
  if (!pageName) return brand;
  return `${brand} | ${pageName}`;
}

export function shopBaseUrl() {
  return (process.env.REACT_APP_BASE_URL || "https://myprivatechemist.com").replace(
    /\/+$/,
    ""
  );
}

export function shopUrl(path = "", query = "") {
  const base = shopBaseUrl();
  const normalizedPath = path ? (path.startsWith("/") ? path : `/${path}`) : "";
  return `${base}${normalizedPath}${query}`;
}

/**
 * @param {{ name: string, url: string }[]} items
 */
export function buildBreadcrumbListSchema(items) {
  if (!items?.length) return null;
  return {
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

/**
 * @param {object[]} schemas - Schema.org objects (without @context)
 */
export function buildSchemaGraph(schemas) {
  const filtered = schemas.filter(Boolean);
  if (!filtered.length) return null;
  if (filtered.length === 1) {
    return { "@context": "https://schema.org", ...filtered[0] };
  }
  return {
    "@context": "https://schema.org",
    "@graph": filtered,
  };
}
